import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { RoleGaurd } from '../shared/services/role-gaurd.service';
import { ReviewModule } from './review/review.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { GeoMapModule } from './geo-map/geo-map.module';
import { GeoMapPrecastModule } from './geo-map-precast/geo-map-precast.module';
import { SampleCollectionFormModule } from './sample-collection-form/sample-collection-form.module';
import { PageNotFoundModule } from './page-not-found/page-not-found.module';
import { AdminModule } from './admin/admin.module';
import { WorksheetModule } from './worksheet/worksheet.module';
import { CustomerValidationModule } from './customer-validation/customer-validation.module';
import { ReportModule } from './report/report.module';
import { SubmitAuthGuard } from '../shared/guard/submit-auth.guard';
import { MergeModule } from './merge/merge.module';
import { CombineModule } from './combine/combine.module';
import { AccountingModule } from './accounting/accounting.module';
import { customerAuthGuard } from './customer-submission/guards/customer-auth.guard';
import { NativeSoilPrintModule } from './native-soil-print/native-soil-print.module';
import { AskGeoModule } from './ask-geo/ask-geo.module';
import { PreviewAttachmentsModule } from './preview-attachments/preview-attachments.module';
import { PreviewTestDataModule } from './preview-test-data/preview-test-data.module';
import { MixDesignModule } from './mix-design/mix-design.module';
import { PrecastWorksheetComponent } from './worksheet-new/precast-worksheet/precast-worksheet.component';
import { UnsavedChangesGuard } from '../shared/guard/unsaved-changes';
import { AsReceivedWorksheetComponent } from './worksheet-new/native-soil-worksheet/as-received-worksheet/as-received-worksheet.component';
import { AsReceivedHistoryComponent } from './worksheet-new/native-soil-worksheet/as-received-history/as-received-history.component';
import { MoistureConditioningHistoryComponent } from './worksheet-new/native-soil-worksheet/moisture-conditioning-history/moisture-conditioning-history.component';
import { NativeSoilHistoryComponent } from './worksheet-new/native-soil-worksheet/native-soil-history/native-soil-history.component';
import { CompactionHistoryComponent } from './worksheet-new/native-soil-worksheet/compaction-history/compaction-history.component';
import { MoistureConditioningWorksheetComponent } from './worksheet-new/native-soil-worksheet/moisture-conditioning-worksheet/moisture-conditioning-worksheet.component';
import { CompactionWorksheetComponent } from './worksheet-new/native-soil-worksheet/compaction-worksheet/compaction-worksheet.component';
import { NativeSoilWorksheetComponent } from './worksheet-new/native-soil-worksheet/native-soil-worksheet/native-soil-worksheet.component';
import { SingleProctorWorksheetComponent } from './worksheet-new/native-soil-worksheet/single-proctor-worksheet/single-proctor-worksheet.component';
import { PrecastPrintModule } from './precast-print/precast-print.module';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => DashboardModule,
    canActivate: [MsalGuard],
  },
  {
    path: 'geoxplore',
    loadChildren: () => GeoMapModule,
    canActivate: [MsalGuard, RoleGaurd],
    data: {
      roles: ['Admin', 'Reportwriter', 'Manager'],
      title: 'Geotherm GeoXplore',
    },
  },
  {
    path: 'geoxplore-precast',
    loadChildren: () => GeoMapPrecastModule,
    canActivate: [MsalGuard, RoleGaurd],
    data: {
      roles: ['Admin', 'Reportwriter', 'Manager'],
      title: 'Geotherm GeoXplore Precast',
    },
  },
  {
    path: 'sampleform',
    loadChildren: () => SampleCollectionFormModule,
    canActivate: [SubmitAuthGuard],
    data: {
      roles: ['Manager', 'Admin', 'Reportwriter'],
      title: 'Geotherm Sample Form',
    },
  },
  {
    path: 'review',
    loadChildren: () => ReviewModule,
    canActivate: [SubmitAuthGuard],
    data: {
      roles: ['Manager', 'Admin', 'Reportwriter', 'Accounting'],
      title: 'Geotherm Review Page',
    },
  },
  {
    path: 'flag',
    loadChildren: () => ReviewModule,
    canActivate: [RoleGaurd],
    data: {
      roles: ['Manager', 'Admin', 'Reportwriter', 'Accounting'],
      title: 'Geotherm Notify Issue Page',
    },
  },
  {
    path: 'split',
    loadChildren: () => ReviewModule,
    canActivate: [MsalGuard, RoleGaurd],
    data: {
      roles: ['Manager', 'Admin', 'Reportwriter'],
      title: 'Geotherm Spilt Project',
    },
  },
  {
    path: 'merge',
    loadChildren: () => MergeModule,
    canActivate: [MsalGuard, RoleGaurd],
    data: {
      roles: ['Manager', 'Admin', 'Reportwriter'],
      title: 'Geotherm Merge Project',
    },
  },
  {
    path: 'combine',
    loadChildren: () => CombineModule,
    canActivate: [MsalGuard, RoleGaurd],
    data: {
      roles: ['Manager', 'Admin', 'Reportwriter'],
      title: 'Geotherm Combine Project',
    },
  },
  {
    path: 'accounting',
    loadChildren: () => AccountingModule,
    canActivate: [MsalGuard, RoleGaurd],
    data: {
      roles: ['Accounting', 'Admin'],
      title: 'Geotherm Accounting',
    },
  },
  {
    path: 'report',
    loadChildren: () => ReportModule,
    canActivate: [MsalGuard, RoleGaurd],
    data: {
      roles: ['Manager', 'Admin', 'Reportwriter', 'Accounting'],
      title: 'Geotherm Report',
    },
  },
  {
    path: 'customer',
    loadChildren: () => CustomerValidationModule,
    canActivate: [customerAuthGuard],
    data: {
      title: 'Geotherm Customer Page',
    },
  },
  {
    path: 'worksheet',
    loadChildren: () => WorksheetModule,
    canActivate: [MsalGuard],
    data: {
      title: 'Geotherm Worksheet',
    },
  },
  {
    path: 'native-soil-print', 
    loadChildren: () => NativeSoilPrintModule,
    canActivate : [MsalGuard],
    data: {
      title: 'Native Soil Print',
    },
  },
  {
    path: 'precast-print', 
    loadChildren: () => PrecastPrintModule,
    canActivate : [MsalGuard],
    data: {
      title: 'Pre Cast Print',
    },
  },
  {
    path: 'ask-geo-result', 
    loadChildren: () => AskGeoModule,
    canActivate : [MsalGuard],
    data: {
      title: 'Ask Geo',
    },
  },
  {
    path: 'mix-design', 
    loadChildren: () => MixDesignModule,
    canActivate : [MsalGuard],
    data: {
      title: 'Mix Design',
    },
  },
  {
    path: 'preview-attachments', 
    loadChildren: () => PreviewAttachmentsModule,
    canActivate : [MsalGuard],
      data: {
        title: 'Preview Attachments',
    },
  },
  {
    path: 'preview-test-data',
    loadChildren: () => PreviewTestDataModule,
    canActivate: [MsalGuard],
    data: {
      title: 'Preview Test Data',
    },
  },
  {
    path: 'admin',
    loadChildren: () => AdminModule,
    canActivate: [MsalGuard, RoleGaurd],
    data: {
      roles: ['Admin', 'Manager'],
      title: 'Geotherm Admin',
    },
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'in-house-dashboard',
    loadChildren: () => import('./tv-dashboard/tv-dashboard.module').then((m) => m.TvDashboardModule),
    canActivate: [MsalGuard],
    data: {
      roles: ['Manager', 'Admin'],
      title: 'Geotherm In-House Dashboard',
    },
  },
  {
    path: 'audit-log-report',
    loadChildren: () => import('./audit-log/audit-log.module').then((m) => m.AuditLogModule),
    canActivate: [MsalGuard, RoleGaurd],
    data: {
      roles: ['Admin'],
      title: 'Geotherm Audit Log',
    },
  },
  {
    path: 'analyze-tr',
    loadChildren: () => import('./analyze-tr/analyze-tr.module').then((m) => m.AnalyzeTrModule),
    canActivate: [MsalGuard, RoleGaurd],
    data: {
      roles: ['Admin'],
      title: 'Geotherm Analyze TR',
    },
  },
  {
    path: 'customer-submission',
    loadChildren: () => import('./customer-submission/customer-submission.module').then((m) => m.CustomerSubmissionModule),
    data: {
      title: 'Geotherm Customer Submission',
    },
  },
  {
    path: 'project-history-360',
    loadChildren: () => import('./project-history-360/project-history-360.module').then((m) => m.ProjectHistory360Module),
    canActivate: [MsalGuard, RoleGaurd],
    data: {
      roles: ['Manager', 'Admin', 'Reportwriter'],
      title: 'Geotherm Project 360 View',
    },
  },
  {
    path: 'precast-worksheet',
    component: PrecastWorksheetComponent,
    canActivate: [MsalGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {
      title: 'Pre Cast Worksheet'
    }
  },
  {
    path: 'as-received-worksheet',
    component: AsReceivedWorksheetComponent,
    canActivate: [MsalGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {
      title: 'As Received Worksheet'
    }
  },
  {
    path: 'as-received-history',
    component: AsReceivedHistoryComponent,
    canActivate: [MsalGuard],
    data: {
      title: 'As Received History'
    }
  },
  {
    path: 'moisture-conditioning-history',
    component: MoistureConditioningHistoryComponent,
    canActivate: [MsalGuard],
    data: {
      title: 'Moisture Conditioning History'
    }
  },
  {
    path: 'native-soil-history',
    component: NativeSoilHistoryComponent,
    canActivate: [MsalGuard],
    data: {
      title: 'Thermal Resistivity History'
    }
  },
  {
    path: 'compaction-history',
    component: CompactionHistoryComponent,
    canActivate: [MsalGuard],
    data: {
      title: 'Compaction History'
    }
  },
  {
    path: 'moisture-conditioning-worksheet',
    component: MoistureConditioningWorksheetComponent,
    canActivate: [MsalGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {
      title: 'Moisture Conditioning Worksheet'
    }
  },
  {
    path: 'compaction-worksheet',
    component: CompactionWorksheetComponent,
    canActivate: [MsalGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {
      title: 'Compaction Worksheet'
    }
  },
  {
    path: 'native-soil-worksheet',
    component: NativeSoilWorksheetComponent,
    canActivate: [MsalGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {
      title: 'Native Soil Worksheet'
    }
  },
  {
    path: 'single-proctor-worksheet',
    component: SingleProctorWorksheetComponent,
    canActivate: [MsalGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {
      title: 'Single Proctor Worksheet'
    }
  },
  {
    path: '**',
    pathMatch: 'full',
    loadChildren: () => PageNotFoundModule,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FeaturesRoutingModule {}
